import { render, staticRenderFns } from "./abstract-car-button.vue?vue&type=template&id=567dcdf4&scoped=true"
import script from "./abstract-car-button.vue?vue&type=script&lang=js"
export * from "./abstract-car-button.vue?vue&type=script&lang=js"
import style0 from "./abstract-car-button.vue?vue&type=style&index=0&id=567dcdf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567dcdf4",
  null
  
)

export default component.exports